import { ConfirmPopup, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface IHireCandidateConfirmationPopupProps {
  isLoading: boolean;
  professionalName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const HireCandidateConfirmationPopup = ({
  isLoading,
  professionalName,
  onClose,
  onConfirm,
}: IHireCandidateConfirmationPopupProps) => (
  // @ts-expect-error - ConfirmPopup still written in JavaScript
  <ConfirmPopup
    title="Mark Candidate as Hired"
    description={
      <Text color={Colors.neutral_500}>
        You're about to mark{' '}
        <Text bold color={Colors.neutral_500}>
          {professionalName}
        </Text>{' '}
        as Hired for this
        <br />
        position. A confirmation message will be sent to the
        <br />
        candidate. This job will remain open for additional
        <br />
        applicants until its status is set to Closed.
      </Text>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    leftButtonAction={onClose}
    leftButtonDisabled={isLoading}
    leftButtonText="Go Back"
    rightButtonAction={onConfirm}
    rightButtonLoading={isLoading}
    rightButtonText="Confirm"
  />
);
